<div fxLayout="column" style="min-width: 480px;">
  <div fxLayout="row" fxLayoutAlign="space-between center" style="padding: 20px 24px;">
    <h2 style="margin: 0;">Assign Page</h2>
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div fxLayout="column" fxLayoutGap="16px" style="padding: 24px;">
    <p style="margin: 0; font-size: 13px; font-weight: 600;">
      {{ data.selectedRecords.length }} attribute(s) selected
    </p>

    <div class="selected-chips" fxLayout="row wrap" fxLayoutGap="8px">
      <span
        *ngFor="let record of data.selectedRecords"
        class="selected-chip"
        [ngClass]="'print-attr-tone--' + (record.Detail?.PrintAttributeType || '')"
      >
        {{ getPrintAttributeTypeLabel(record.Detail?.PrintAttributeType || '') }}
      >
        {{ record.Detail?.PrintAttributeName || 'Untitled Attribute' }}
        <mat-icon class="chip-x">close</mat-icon>
      </span>
    </div>

    <p style="margin: 0; line-height: 1.4;">
      Select a page to assign to the attributes above. Position will remain unchanged.
    </p>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>Page</mat-label>
      <mat-select [(ngModel)]="selectedPrintPageId">
        <mat-option *ngFor="let item of printPagesList" [value]="item.Id">
          {{ item.PageFrom }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-divider></mat-divider>

  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px" style="padding: 16px 24px 24px;">
    <button mat-stroked-button type="button" (click)="closeDialog()">Cancel</button>
    <button mat-raised-button type="button" color="primary" [disabled]="!selectedPrintPageId" (click)="apply()">
      Apply
    </button>
  </div>
</div>
